export const SET_CONFIG_LIST = "SET_CONFIG_LIST";
export const SET_CHECK_GIB_SELLER_INFO_DATA = "SET_CHECK_GIB_SELLER_INFO_DATA";
export const SET_CHECK_NEED_PASSWORD_CHANGE = "SET_CHECK_NEED_PASSWORD_CHANGE";
export const SET_TOASTER_DATA = "SET_TOASTER_DATA";
export const SET_UPLOAD_IMAGE_SUCCESS = "SET_UPLOAD_IMAGE_SUCCESS";
export const TRIGGER_DEAL_TABLE_REFRESH = "TRIGGER_DEAL_TABLE_REFRESH";
export const SET_CUSTOM_DEAL_NOTIFICATION = "SET_CUSTOM_DEAL_NOTIFICATION";
